module.exports = __webpack_public_path__ + "img/company-door.54c7ae7f.jpg";